import React, { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import './aboutUs.scss';
import { ComputerGraphImage, DefaultBlot } from 'src/assets';
import { BlackBox, CustomLink } from 'src/components';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const AboutUs = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="about-us">
      <div className={`about-us-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="about-us-title">
          <supertitle>{t('title:aboutUs')}</supertitle>
          <h1>
            <blue-text>{t('aboutUs:who')}</blue-text>{' '}
            <blue-underline>{t('aboutUs:we')}</blue-underline>
          </h1>
          <text>
            <Trans i18nKey="aboutUs:subtitle" />
          </text>
          <ul>
            <li>
              <text>
                <span>{t('aboutUs:stock')}</span> {t('aboutUs:stockNext')}
              </text>
            </li>
            <li>
              <text>
                <span>{t('aboutUs:crypto')}</span> {t('aboutUs:cryptoNext')}
              </text>
            </li>
            <li>
              <text>
                {t('aboutUs:indexPrev')} <span>{t('aboutUs:index')}</span> {t('aboutUs:indexNext')}
              </text>
            </li>
            <li>
              <text>
                {t('aboutUs:forexPrev')} <span>{t('aboutUs:forex')}</span>
              </text>
            </li>
            <li>
              <text>
                <span>{t('aboutUs:raw')}</span> {t('aboutUs:rawNext')}
              </text>
            </li>
          </ul>
        </div>
        <div className="about-us-image">
          <div className="about-us-image-content">
            <div className="about-us-box-1">
              <BlackBox title={t('title:millTitle')} subtitle={t('title:millSub')} />
            </div>
            <div className="about-us-box-2">
              <BlackBox title={t('title:comissionTitle')} subtitle={t('title:comissionSub')} />
            </div>
            <img
              src={ComputerGraphImage}
              alt={ComputerGraphImage}
              className="about-us-image-main"
            />
            <img src={DefaultBlot} alt={DefaultBlot} className="about-us-image-1" />
          </div>
        </div>
      </div>
    </div>
  );
};
